import { Component, Input } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'screenshot-smart-pill',
    templateUrl: './screenshot-smart-pill.component.html',
    styleUrls: ['./screenshot-smart-pill.component.scss'],
    standalone: false
})
export class ScreenshotSmartPillComponent {
    @Input() name: string;
    @Input() screenshotId: number;

    constructor() { }

    preview() : void {
      const url = `${environment.API_URL}/borrower-progression-screenshot/${this.screenshotId}/preview`;
      window.open(url, '_blank');
    }
}
